// tslint:disable:no-empty-interface
import { IMailboxDescription } from '@valhalla/data/entities';
import { Observable } from 'rxjs';

export abstract class EmailDataHttpService {
	abstract getMailboxes(): Observable<IGetMailboxesResult>;
	abstract deleteMailBox(mailboxId: number): Observable<any>;
	abstract addToFavorites(requestParams: IAddToFavoritesRequestParams): Observable<any>;
	abstract markAllAsRead(folderId: number): Observable<any>;
	abstract clearFolder(folderId: number): Observable<any>;
}

export interface IGetMailboxesResult {
	mailBoxes: Array<IMailboxDescription>;
}

export interface IAddToFavoritesRequestParams {
	folderId: number;
	folderName: string;
}
